import baseApi from '../common/baseApi.js'

const applyOnlineService = {
	/**
	 * Get Product documents (IPID, ToB, Claims, PolicyWording)
	 *
	 * @async
	 * @param {number} productId
	 * @param {number} areaOfCoverId
	 * @param {number} levelOfCoverId
	 * @param {date} policyStartDate
	 * @param {string} language eng default - get language func - eng docs and germany docs
	 * @param {string} docType 4 type: IPID, ToB, Claims, PolWording
	 * @returns {list} list file {documentType, fileUrl, fileNameWithExtension, fileContent}
	 */
	async getProductDocumentsAsync(
		productId,
		areaOfCoverId,
		levelOfCoverId,
		policyStartDate,
		language = 'en',
		docType = '',
		getContent = false,
		productDocumentsGlobal,
	) {
		try {
			let paramQuery = `productId=${productId}&areaOfCoverId=${areaOfCoverId}&levelOfCoverId=${levelOfCoverId}&policyStartDate=${policyStartDate}&language=${language}`
			if (getContent) {
				paramQuery += `&getContent=${getContent}`
			}

			// check if productDocs is exist in session
			let productDocs = productDocumentsGlobal.find(
				(p) =>
					p.productId === productId &&
					p.areaOfCoverId === areaOfCoverId &&
					p.levelOfCoverId === levelOfCoverId,
			)

			if (productDocs && getContent == false) {
				productDocs = productDocs.productDocs
			} else {
				productDocs = await baseApi.get(`api/getProductDocuments?${paramQuery}`)

				productDocumentsGlobal.push({
					productId,
					areaOfCoverId,
					levelOfCoverId,
					productDocs,
				})
			}

			if (docType) {
				var doc = productDocs.find((p) => p.documentType === docType)
				return doc || null
			}

			return productDocs
		} catch (e) {
			console.error('ApplyOnlineService - getProductDocuments: ', e)
			throw e
		}
	},

	/**
	 * Get specific config layout (email contact, logo header, logo footer ...)
	 *
	 * @async
	 * @returns {object} config layout object {emailContact: string, headerLogoPath: string, footerLogoPath: string}
	 */
	async getSpecificConfigLayoutAsync() {
		let domain = await baseApi.get(`api/getDomain`)

		// default value
		let configResult = {
			emailContact: 'info@morgan-price.com',
			headerLogoPath: 'assets/images/mp-international.svg',
			footerLogoPath: 'assets/images/mp-international-white-logo.png',
			footerAddress: `<small>
                        <p>© 2021 Morgan Price International Healthcare Ltd.</p>
                        <br/>
                        Morgan Price International Healthcare Limited are authorised and regulated by the Financial Conduct Authority. FCA FRN : 313738
                        <br/>
                        Registered Address : 2 Penfold Drive, Gateway 11, Wymondham, Norfolk, NR18 0WZ, United Kingdom. Reg.Number: 03771138
                      </small>`,
			tel: '01379646730',
			telDisplay: '+44 (0) 1379 646730',
		}

		if (domain === 'eu') {
			configResult.emailContact = 'info@morgan-price.eu'
			configResult.headerLogoPath = 'assets/images/mp-europe.svg'
			configResult.footerLogoPath = 'assets/images/mp-europe-white-logo.png'
			configResult.footerAddress = `<small>
                                      <p>© 2021 Morgan Price (Europe) ApS.</p>
                                      <br/>
                                      Morgan Price (Europe) ApS are authorised and regulated by the Danish Financial Supervisory Authority. FTID Number : 36351
                                      <br/>
                                      Registered Address : Morgan Price (Europe) ApS, ØENS Virksomhedsadministration ApS, Lergravsvej 59, 1. , 2300 København s, Denmark. CVR Number 41127635.
                                    </small>`
									
								}

		return configResult
	},

	/**
	 * Get insurerDetails for schema file
	 * @param {*} productId
	 * @param {*} productName
	 * @param {*} selectedDate
	 * @async
	 * @returns
	 */
	async getInsurerDetailsAsync(productId, productName, selectedDate) {
		const params = new URLSearchParams([
			['productId', productId],
			['productName', productName],
			['selectedDate', selectedDate],
		])
		return await baseApi.get(`api/insurerDetails?${params}`)
	},

	/**
	 * Get language by country - de or en
	 * @param {list option} optionData
	 * @param {string} residenceCountryId
	 * @param {string} homeCountryId
	 * @returns {string} de || en - default en
	 */
	getLanguageByCountry(optionData, residenceCountryId, homeCountryId) {
		let residenceCountry = optionData.residenceCountries.find((v) => v.value === residenceCountryId).text || ''
		let homeCountry = optionData.countries.find((v) => v.value === homeCountryId).text || ''
		if (residenceCountry === homeCountry && residenceCountry.toLowerCase() === 'germany') {
			return 'de'
		}

		return 'en'
	},
}

export default applyOnlineService
